export default function SummaryStep({
  qty,
  country,
  fulfilment,
  collection,
  form = {}, 
  onCheckout,
  isProcessing
}) {
  const bookPrice = 1900;
  const subtotal = qty * bookPrice;

  const isValid =
    form.firstName?.trim() &&
    form.lastName?.trim() &&
    form.email?.trim() &&
    form.phone?.trim() &&
    (
      fulfilment === "collection"
        ? collection
        : (
            form.address?.trim() &&
            form.city?.trim()
          )
    );

  return (
    <div
      style={{
        marginTop: 40
      }}
    >
      <h3
        style={{
          fontSize: "14px",
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: "#C4773B",
          marginBottom: 20
        }}
      >
        Step 5 — Review Your Order
      </h3>

      <div
        style={{
          border: "1px solid rgba(26,22,17,0.12)",
          padding: 24,
          background: "rgba(26,22,17,0.02)"
        }}
      >

        {/* COUNTRY */}

        <SummaryRow
          label="Country"
          value={country}
        />

        {/* FULFILMENT */}

        <SummaryRow
          label="Fulfilment"
          value={
            fulfilment === "collection"
              ? "Collection"
              : "Delivery"
          }
        />

        {/* COLLECTION */}

        {fulfilment === "collection" &&
          collection && (
            <>
              <SummaryRow
                label="Collection Point"
                value={`${collection.name}, ${collection.address}`}
              />

              
            </>
          )}

        {/* DELIVERY */}

        {fulfilment === "delivery" && (
          <>
            <SummaryRow
              label="Delivery Address"
              value={form.address}
            />

            <SummaryRow
              label="Town / City"
              value={form.city}
            />

            {form.notes && (
              <SummaryRow
                label="Instructions"
                value={form.notes}
              />
            )}
          </>
        )}

        {/* CUSTOMER */}

        <SummaryRow
          label="Name"
          value={`${form.firstName} ${form.lastName}`}
        />

        <SummaryRow
          label="Email"
          value={form.email}
        />

        <SummaryRow
          label="Phone"
          value={form.phone}
        />

        {/* TOTAL */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 20,
            paddingTop: 20,
            borderTop:
              "1px solid rgba(26,22,17,0.12)"
          }}
        >
          <span
            style={{
              fontFamily:
                "'Cormorant Garamond', serif",
              fontSize: 24
            }}
          >
            Total
          </span>

          <span
            style={{
              fontFamily:
                "'Cormorant Garamond', serif",
              fontSize: 24,
              color: "#C4773B"
            }}
          >
            Ksh{subtotal.toFixed(2)}
          </span>
        </div>

        {fulfilment === "delivery" && (
          <div
            style={{
              marginTop: 12,
              fontSize: 13,
              color: "#8B7355",
              lineHeight: 1.6
            }}
          >
            Delivery fee is not included.
            Someone from our team will
            contact you to arrange delivery
            and payment with the rider or
            courier.
          </div>
        )}
      </div>

      {/* PAYMENT BUTTON */}

      <button
        disabled={!isValid}
        onClick={onCheckout}
        style={{
          width: "100%",
          marginTop: 20,
          padding: "16px",
          border: "none",
          background: isValid
            ? "#1A1611"
            : "#D8D3CC",
          color: isValid
            ? "#F5F0E8"
            : "#8B7355",
          cursor: isValid
            ? "pointer"
            : "not-allowed",
          textTransform: "uppercase",
          letterSpacing: "0.16em",
          transition: "0.2s"
        }}
      >
          {isProcessing
            ? "Processing..."
            : "Proceed To Payment"}
      </button>

      {!isValid && (
        <p
          style={{
            marginTop: 10,
            fontSize: 13,
            color: "#8B7355"
          }}
        >
          Please complete all required
          fields before proceeding.
        </p>
      )}
    </div>
  );
}

function SummaryRow({
  label,
  value
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent:
          "space-between",
        gap: 20,
        padding: "10px 0",
        borderBottom:
          "1px solid rgba(26,22,17,0.08)"
      }}
    >
      <span
        style={{
          color: "#8B7355",
          fontSize: 14
        }}
      >
        {label}
      </span>

      <span
        style={{
          textAlign: "right",
          fontSize: 14,
          maxWidth: "60%"
        }}
      >
        {value}
      </span>
    </div>
  );
}